/* LUNA product card behaviour — F4 / D20-D21 / D50.
   Generic over option names: "Size" -> chips, "Origin" -> upgrade row, anything else -> chip rows.
   Handles 1-3 dimensions (Chancla Pro is size-only; Hemp Monkey has two colour axes).
   Cart work is delegated to luna-cart.js so the drawer logic lives in one place.
   D50: customer-facing copy never says "Imported" — the standard build is unnamed,
   the upgrade is "Made in USA" / "Handcrafted to order".
   D93 bugfix: the featured <img> carries srcset, and srcset OUTRANKS src — so a
   swatch tap that only set .src never changed the picture. The swap now clears
   srcset/sizes first.
   D125: builder products render a link in place of the quick-add button and carry no
   panel and no data blob, so this file must tolerate all three being absent.
   D169: the card can open on a colourway that is not values[0], so the starting
   colour is read off the marked swatch rather than assumed.
   D175: a sold-out selection ends in a Back in Stock offer, not a dead button.
   D422: the quick-add Add to Cart no longer repeats the price.
   D423: on phones the panel is MOVED TO <body> and shown as a bottom sheet.
   D425 (Liv, 09-21): "change button is not working". IT WAS DEAD, and the cause was
   this file. Clicking Change set st.size = null and called render(), but render()
   opens by reading the remembered size back out of localStorage and re-applying it
   whenever st.size is empty - which it had just made empty. So Change cleared the
   size and render put it straight back, every time, and the panel never changed.
   Fixed with recallOff: once the customer asks to change, the recall shortcut is
   suppressed for as long as that panel stays open. Reset on open so the next visit
   still gets offered their usual size. localStorage is deliberately NOT cleared -
   the size they pick next overwrites it on add to cart. */
(function(){
  if(window.__lunaCard) return; window.__lunaCard = true;
  var KEY='luna.size';
  var PHONE='(max-width:749px)';
  var BAG='<svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.45 4.7h9.1l-.62 7.05a.9.9 0 0 1-.9.82H3.97a.9.9 0 0 1-.9-.82L2.45 4.7Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/><path d="M5.05 6V3.9a1.95 1.95 0 0 1 3.9 0V6" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg>';
  var BELL='<svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1.7a3.3 3.3 0 0 0-3.3 3.3c0 2.9-1.1 3.8-1.1 3.8h8.8s-1.1-.9-1.1-3.8A3.3 3.3 0 0 0 7 1.7Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/><path d="M8.2 11.1a1.3 1.3 0 0 1-2.4 0" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg>';
  var REMIND='Remind me when available';
  function recall(){ try{ return localStorage.getItem(KEY); }catch(e){ return null; } }
  function store(v){ try{ localStorage.setItem(KEY,v); }catch(e){} }
  function money(c){ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$'+(c/100).toFixed(2); }
  function isPhone(){ return !!(window.matchMedia && window.matchMedia(PHONE).matches); }

  function init(card){
    if(card.__luna) return; card.__luna = true;

    /* D125: the quick-add trigger is selected as `button.luna-card__qa`, never the bare
       class. A builder card renders an <a> with that same class so it keeps the pill
       styling, and this selector is what stops the anchor from being hijacked by the
       quick-add handler below. */
    var panel = card.querySelector('.luna-card__panel');
    var trigger = card.querySelector('button.luna-card__qa');
    var blob = card.querySelector('[data-luna-data]');
    var linkEl = card.querySelector('.luna-card__link');
    var productUrl = linkEl ? linkEl.getAttribute('href') : null;
    var media = card.querySelector('.luna-card__media');

    var data = null;
    if(blob){ try{ data = JSON.parse(blob.textContent); }catch(e){ data = null; } }

    var imgs = Array.prototype.slice.call(card.querySelectorAll('.luna-card__media img'));
    var bars = Array.prototype.slice.call(card.querySelectorAll('.luna-card__pg button'));
    var locked = false;

    function showImg(i){
      if(i >= imgs.length) i = 0;
      imgs.forEach(function(m,n){ m.classList.toggle('is-show', n===i); });
      bars.forEach(function(b,n){ b.setAttribute('aria-current', String(n===i)); });
    }
    bars.forEach(function(b){ b.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation(); locked = true; showImg(+b.dataset.i);
    }); });
    card.addEventListener('mouseenter', function(){ if(imgs.length>1 && !locked && !card.classList.contains('is-open')) showImg(1); });
    card.addEventListener('mouseleave', function(){ if(imgs.length>1 && !locked && !card.classList.contains('is-open')) showImg(0); });

    /* Image swapping and swatches above work for EVERY card, builders included.
       Only the buy flow below needs the variant data and the panel. Bailing out
       early also matters structurally: init() runs inside a forEach, so one card
       throwing on a null trigger would abort every remaining card in the grid. */
    if(!data || !panel || !trigger) return;

    var opts = data.options || [], variants = data.variants || [];
    var sizeOpt = null, originOpt = null, colourOpt = null, others = [];
    opts.forEach(function(o){
      if(/^size$/i.test(o.name)) sizeOpt = o;
      else if(/^origin$/i.test(o.name)) originOpt = o;
      else if(/^colou?r$/i.test(o.name) && !colourOpt) colourOpt = o;
      else others.push(o);
    });
    var st = {};
    if(colourOpt) st[colourOpt.name] = colourOpt.values[0];
    if(originOpt) st[originOpt.name] = originOpt.values[0];
    others.forEach(function(o){ st[o.name] = o.values[0]; });
    st.size = null;

    /* D425: set when the customer clicks Change. While it is true, render() must not
       re-apply the remembered size, which is the whole bug. */
    var recallOff = false;

    /* D169: the swatch row decides which colourway the card is showing, and the Liquid
       may mark one that is not values[0] (a theme-side default). Read it back off the
       marked chip so Quick Add adds the pair the customer is actually looking at
       instead of silently falling through to the first value. data-opt names the
       option the row stands for: this file matches a colour option on an exact
       Color/Colour name, which is narrower than the snippet's contains-match, so a
       Lace Color row lands in `others` here and cannot be inferred from colourOpt. */
    var swWrap = card.querySelector('.luna-card__sw');
    var swOn = swWrap && swWrap.querySelector('button[aria-current="true"]');
    var swName = swWrap && swWrap.getAttribute('data-opt');
    if(swOn && swName && st[swName] !== undefined && swOn.getAttribute('data-v')){
      st[swName] = swOn.getAttribute('data-v');
    }

    function match(over){
      var want = {};
      opts.forEach(function(o){
        var v = (over && over[o.name] !== undefined) ? over[o.name]
              : (o === sizeOpt ? st.size : st[o.name]);
        want[o.name] = v;
      });
      return variants.filter(function(v){
        return opts.every(function(o,i){
          var w = want[o.name];
          return w == null || v.o[i] === w;
        });
      });
    }
    function availableFor(sizeVal, originVal){
      var over = {}; if(sizeOpt) over[sizeOpt.name] = sizeVal;
      if(originOpt) over[originOpt.name] = originVal;
      return match(over).some(function(v){ return v.a; });
    }
    function current(){ var m = match(); return m.length ? m[0] : null; }
    function otherOrigin(){
      if(!originOpt) return null;
      var cur = st[originOpt.name];
      return originOpt.values.filter(function(v){ return v !== cur; })[0] || null;
    }
    /* Nothing buyable in ANY combination - the product is gone, not just this pick. */
    function anythingLeft(){ return variants.some(function(v){ return v.a; }); }

    card.querySelectorAll('.luna-card__sw button').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        if(swName && st[swName] !== undefined) st[swName] = b.dataset.v;
        else if(colourOpt) st[colourOpt.name] = b.dataset.v;
        card.querySelectorAll('.luna-card__sw button').forEach(function(o){ o.setAttribute('aria-current', String(o===b)); });
        if(b.dataset.img && imgs[0]){
          imgs[0].removeAttribute('srcset');
          imgs[0].removeAttribute('sizes');
          imgs[0].src = b.dataset.img;
          imgs[0].alt = data.title + ' - ' + b.dataset.v;
        }
        locked = false; showImg(0);
        if(card.classList.contains('is-open')) render();
      });
    });

    /* ----- D423: the bottom sheet -----
       On a phone the panel leaves the card entirely and becomes a sheet on <body>.
       It is MOVED rather than merely re-positioned because .luna-card carries
       container-type for D419: a contained ancestor is specified to become the
       containing block for fixed descendants, so position:fixed inside the card is not
       something to rely on across engines. Moving the node sidesteps the question.

       CRITICAL, and it broke the first build: every design token in this theme is
       declared on `.luna` in luna-tokens.css, and `.luna *` is what sets border-box.
       A panel appended to <body> has no `.luna` ancestor, so it lost the lot. So the
       panel CARRIES the `luna` class while it is a sheet, and drops it on the way back
       into the card. */
    var sheetOn = false, sheetBg = null;

    function onResize(){ if(sheetOn && !isPhone()) closePanel(); }

    function openPanel(){
      recallOff = false;              /* D425: each open starts fresh */
      card.classList.add('is-open');
      render();
      if(!isPhone()) return;
      sheetOn = true;
      sheetBg = document.createElement('div');
      sheetBg.className = 'luna-sheet-bg';
      sheetBg.addEventListener('click', closePanel);
      document.body.appendChild(sheetBg);
      document.body.appendChild(panel);
      panel.classList.add('luna', 'is-sheet');
      document.body.classList.add('luna-sheet-open');
      window.addEventListener('resize', onResize);
      /* next tick so the browser has a frame at translateY(100%) to animate FROM */
      setTimeout(function(){
        panel.classList.add('is-up');
        if(sheetBg) sheetBg.classList.add('is-up');
      }, 10);
      var first = panel.querySelector('button, a');
      if(first) first.focus();
    }

    function closePanel(){
      card.classList.remove('is-open');
      if(!sheetOn) return;
      sheetOn = false;
      window.removeEventListener('resize', onResize);
      document.body.classList.remove('luna-sheet-open');
      panel.classList.remove('is-up');
      var bg = sheetBg; sheetBg = null;
      if(bg) bg.classList.remove('is-up');
      setTimeout(function(){
        panel.classList.remove('is-sheet', 'luna');
        if(media) media.appendChild(panel);
        if(bg && bg.parentNode) bg.parentNode.removeChild(bg);
      }, 300);
    }

    function render(){
      var rec = recall();
      var anyLeft = anythingLeft();
      /* D425: recallOff is the first term. Without it, Change is a no-op. */
      var useRecall = !recallOff && !st.size && rec && sizeOpt && sizeOpt.values.indexOf(rec) > -1
                      && availableFor(rec, originOpt ? st[originOpt.name] : null);
      if(useRecall) st.size = rec;

      var head = anyLeft ? (useRecall ? 'Your size' : 'Choose') : 'Sold out';
      var h = '<div class="luna-qa__top"><p class="luna-qa__t">' + head +
              '</p><button class="luna-qa__x" type="button" aria-label="Close">&times;</button></div>';

      others.forEach(function(o){
        h += '<div class="luna-opt"><p class="luna-opt__l">' + o.name + '</p><div class="luna-chips">' +
          o.values.map(function(v){
            return '<button type="button" class="luna-chip' + (st[o.name]===v ? ' is-on' : '') +
                   '" data-opt="' + o.name + '" data-v="' + v + '">' + v + '</button>';
          }).join('') + '</div></div>';
      });

      if(sizeOpt){
        if(useRecall){
          h += '<div class="luna-opt"><p class="luna-opt__l">Size</p><div class="luna-recall">' +
               '<span class="luna-recall__s">' + st.size + '</span>' +
               '<button type="button" class="luna-recall__c" data-change>Change</button></div></div>';
        } else {
          h += '<div class="luna-opt"><p class="luna-opt__l">' + sizeOpt.name + '</p><div class="luna-chips">' +
            sizeOpt.values.map(function(v){
              var ok = availableFor(v, originOpt ? st[originOpt.name] : null);
              var res = !ok && originOpt && availableFor(v, otherOrigin());
              return '<button type="button" class="luna-chip' + (v===st.size ? ' is-on' : '') +
                     (ok ? '' : ' is-oos') + (res ? ' is-rescuable' : '') + '" data-s="' + v + '">' + v + '</button>';
            }).join('') + '</div></div>';
        }
      }

      if(originOpt){
        var on = st[originOpt.name] !== originOpt.values[0];
        h += '<div class="luna-up' + (on ? ' is-on' : '') + '">' +
             '<span class="luna-flag" aria-hidden="true"><span class="luna-flag__c"></span></span>' +
             '<span class="luna-up__txt"><b>Upgrade to ' + (data.originLabel || 'Made in USA') + '</b><em>' + (data.originNote || 'Handcrafted to order') + '</em></span>' +
             (data.originDelta ? '<span class="luna-up__p">+' + money(data.originDelta) + '</span>' : '') +
             '<button class="luna-sw" type="button" role="switch" aria-checked="' + on + '" aria-label="Upgrade to ' +
             (data.originLabel || 'Made in USA') + '"><span class="luna-sw__k"></span></button></div>';
      }

      var v = current();
      var canBuy = !!(v && v.a) && (!sizeOpt || st.size);
      var rescued = false;
      if(sizeOpt && st.size && !canBuy && originOpt && availableFor(st.size, otherOrigin())){
        rescued = true;
        var to = otherOrigin();
        if(to === 'USA'){
          h += '<div class="luna-rescue"><p><b>' + st.size + ' is sold out.</b> Available as Made in USA.' +
               '<br><button type="button" data-switch="USA">Switch to Made in USA</button></p></div>';
        } else {
          h += '<div class="luna-rescue"><p><b>' + st.size + ' is sold out as Made in USA.</b> Available in the standard version.' +
               '<br><button type="button" data-switch="' + to + '">Switch back</button></p></div>';
        }
      } else if(sizeOpt && st.size && !canBuy){
        h += '<p class="luna-dead">' + st.size + ' is sold out.</p>';
      }

      /* D175 (Liv): a disabled button was the end of the road. Where there is nothing
         to buy - the whole product gone, or the chosen size gone with no other build
         to rescue it - offer the Back in Stock signup instead. It is a LINK to the
         product page rather than a signup here, on purpose: the Back in Stock widget
         only builds its popover where the theme has set _BISConfig.product, which is
         product pages only. One extra click, real plumbing. */
      if(canBuy){
        h += '<button class="luna-btn luna-btn--buy luna-atc" type="button">' +
             '<span>Add to Cart</span>' + BAG + '</button>';
      } else if(!rescued && productUrl && (!anyLeft || !sizeOpt || st.size)){
        h += '<a class="luna-btn luna-atc luna-remind" href="' + productUrl + '">' +
             '<span>' + REMIND + '</span>' + BELL + '</a>';
      } else {
        h += '<button class="luna-btn luna-btn--buy luna-atc" type="button" disabled>' +
             (st.size || !sizeOpt ? 'Sold out' : 'Select a size') + '</button>';
      }
      panel.innerHTML = h;
    }

    trigger.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      openPanel();
    });

    panel.addEventListener('click', function(e){
      e.stopPropagation();
      var t = e.target.closest('button'); if(!t) return;
      if(t.classList.contains('luna-qa__x')){ closePanel(); trigger.focus(); return; }
      if(t.dataset.s){ st.size = t.dataset.s; render(); return; }
      if(t.dataset.opt){ st[t.dataset.opt] = t.dataset.v; render(); return; }
      if(t.dataset.switch && originOpt){ st[originOpt.name] = t.dataset.switch; render(); return; }
      /* D425: recallOff is what makes this button do anything at all. */
      if(t.hasAttribute('data-change')){ st.size = null; recallOff = true; render(); return; }
      if(t.classList.contains('luna-sw') && originOpt){
        st[originOpt.name] = otherOrigin(); render(); return;
      }
      if(t.classList.contains('luna-atc') && !t.disabled){
        var variant = current(); if(!variant) return;
        t.disabled = true;
        var label = t.innerHTML;
        var addFn = (window.lunaCart && window.lunaCart.add)
          ? window.lunaCart.add
          : function(items){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:items}) }).then(function(r){ return r.json(); }); };

        addFn([{ id: variant.id, quantity: 1 }])
          .then(function(){
            if(st.size) store(st.size);
            t.classList.add('is-done'); t.innerHTML = '<span>Added</span>';
            setTimeout(function(){
              closePanel();
              st.size = null; t.disabled = false;
              t.classList.remove('is-done'); t.innerHTML = label;
            }, 900);
          })
          .catch(function(err){
            t.disabled = false;
            t.innerHTML = '<span>' + (err && err.message ? err.message : 'Try again') + '</span>';
            setTimeout(function(){ t.innerHTML = label; }, 2500);
          });
      }
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && card.classList.contains('is-open')){
        closePanel(); trigger.focus();
      }
    });
  }

  /* D126: Stamped sweeps the page for review badges once, when its widget finishes
     loading. Two of our surfaces produce badges after that: the gear tabs clone their
     panels out of <template> on first click, and the collection grid re-renders on
     every filter change. Both funnel through here. */
  function badges(){
    try{
      if(!window.StampedFn) return;
      if(typeof StampedFn.loadBadges === 'function') StampedFn.loadBadges();
      else if(typeof StampedFn.reloadUUID === 'function') StampedFn.reloadUUID();
    }catch(e){}
  }

  function scan(root){
    (root||document).querySelectorAll('.luna-card').forEach(init);
    badges();
  }
  document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  if(document.readyState !== 'loading') scan(document);
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  window.lunaCardScan = scan;
})();